import axiosInstance from "@/api/axios";

export default {
  namespaced: true,
  state: {
    status: null,
    conversations: [],
    unreadCount: {},
    unreadmessageCount: 0,
    currentRoute: null,
    loading: false,
    initializing: false,
    chat: [],
    singleRoom: {}
  },
  getters: {
    getStatus(state) {
      return state.status;
    },
    getConversations(state) {
      return state.conversations;
    },
    getUnreadMessagesCount(state) {
      return state.unreadmessageCount;
    },
    getChats(state) {
      return state.chat;
    },
    getSingleRoom(state) {
      return state.singleRoom;
    },
    // Get chat by ID
    getChatById: (state) => (chatId) => {
      if (!chatId) return null;
      return state.chat.find(c => c && (c._id === chatId || c.id === chatId)) || null;
    },

    // Get chat by conversation key
    getChatByConversationKey: (state) => (conversationKey) => {
      if (!conversationKey) return null;
      return state.chat.find(c => c && c.conversationKey === conversationKey) || null;
    }
  },
  mutations: {
    setStatus(state, data) {
      state.status = data;
    },
    setLoading(state, data) {
      state.loading = data;
    },
    setInitializing(state, data) {
      state.initializing = data;
    },
    setConversations(state, data) {
      var array = data;
      array.sort((a, b) => {
        var aTime = new Date(a.date);
        var bTime = new Date(b.date);
        if (aTime.getTime() > bTime.getTime()) return -1;
        else if (aTime.getTime() < bTime.getTime()) return 1;
        return 0;
      });
      state.conversations = array;
    },
    setConversation(state, data) {
      state.conversations = state.conversations.map(c =>
        c.uniqueName == data.uniqueName ? data : c
      );
    },
    setUnreadMessageCount(state, param) {
      state.unreadCount[param.key] = param.value;
      state.unreadCount = { ...state.unreadCount };
    },
    setSingleRoom(state, data) {
      if (data) {
        // Ensure messages array exists
        if (!data.messages) {
          data.messages = [];
        }
        // Ensure participants array exists
        if (!data.participants) {
          data.participants = [];
        }
        // Ensure the chat has an _id
        if (!data._id && data.id) {
          data._id = data.id;
        }
      }
      state.singleRoom = data;
    },
    SET_UNREAD_MESSAGES_COUNT(state, data) {
      state.unreadmessageCount = data;
    },
    setRoute(state, route) {
      state.currentRoute = route;
    },
    SET_CHAT(state, chat) {
      state.chat = chat;
    },

    // New mutation: Add a chat to the list
    ADD_CHAT(state, chat) {
      if (!chat) {
        console.warn('Attempted to add null or undefined chat');
        return;
      }

      const chatId = chat._id || chat.id;
      if (!chatId) {
        console.warn('Chat object missing _id:', chat);
        return;
      }

      // Find existing chat index
      const existingIndex = state.chat.findIndex(c => {
        if (!c) return false;
        return c._id === chatId || c.id === chatId;
      });

      if (existingIndex !== -1) {
        // Update existing chat while preserving important data
        const existingChat = state.chat[existingIndex];

        // Merge the chat data, but keep selectedUser if it exists in new chat
        // or preserve existing selectedUser if new one doesn't have it
        const mergedChat = {
          ...existingChat,
          ...chat,
          // If the new chat has selectedUser, use it; otherwise keep existing
          selectedUser: chat.selectedUser || existingChat.selectedUser
        };

        state.chat[existingIndex] = mergedChat;
      } else {
        // Add new chat to the beginning
        state.chat.unshift(chat);
      }

      // Ensure reactivity - this triggers Vue's reactivity system
      state.chat = [...state.chat];
    },

    // New mutation: Add a local message to a chat
    ADD_LOCAL_MESSAGE(state, { roomId, message }) {
      if (!roomId || !message) return;

      const pushToRoom = (room) => {
        if (!room) return;
        if (!Array.isArray(room.messages)) room.messages = [];
        room.messages.push(message);
        room.lastMessage = message;
        room.lastActivityAt = message.createdAt || new Date().toISOString();
      };

      if (state.singleRoom && state.singleRoom._id === roomId) {
        pushToRoom(state.singleRoom);
      }

      const idx = state.chat.findIndex(c => c && c._id === roomId);
      if (idx !== -1) {
        pushToRoom(state.chat[idx]);
        state.chat = [...state.chat];
      }
    },

    // New mutation: Update a chat
    UPDATE_CHAT(state, updatedChat) {
      if (!updatedChat) return;

      const chatId = updatedChat._id || updatedChat.id;
      if (!chatId) return;

      const index = state.chat.findIndex(c => {
        if (!c) return false;
        return c._id === chatId || c.id === chatId;
      });

      if (index !== -1) {
        // Update the chat while preserving reactivity
        const existingChat = state.chat[index];
        const mergedChat = {
          ...existingChat,
          ...updatedChat,
          // Preserve selectedUser if it exists
          selectedUser: updatedChat.selectedUser || existingChat.selectedUser
        };

        state.chat[index] = mergedChat;

        // Move to top if it's the latest activity
        const chat = state.chat.splice(index, 1)[0];
        if (chat) {
          state.chat.unshift(chat);
        }
      }
    },
    SET_CHAT_UNREAD_COUNT(state, { chatId, userId, count }) {
  const chat = state.chat.find(c => c && c._id === chatId);
  if (chat) {
    if (!chat.unreadCount) chat.unreadCount = {};
    chat.unreadCount[userId] = count;
    chat.currentUserUnreadCount = count;
    state.chat = [...state.chat]; // trigger reactivity
  }
  if (state.singleRoom && state.singleRoom._id === chatId) {
    if (!state.singleRoom.unreadCount) state.singleRoom.unreadCount = {};
    state.singleRoom.unreadCount[userId] = count;
    state.singleRoom.currentUserUnreadCount = count;
  }
},

    // New mutation: Update group details
    UPDATE_GROUP_DETAILS(state, { groupId, updates }) {
      // Update in chat list
      const chatIndex = state.chat.findIndex(c => c && c._id === groupId);
      if (chatIndex !== -1) {
        state.chat[chatIndex] = {
          ...state.chat[chatIndex],
          ...updates
        };
      }

      // Update in single room if it's the same
      if (state.singleRoom && state.singleRoom._id === groupId) {
        state.singleRoom = { ...state.singleRoom, ...updates };
      }
    },

    clearRoomMessages(state, roomId) {
      if (state.singleRoom && state.singleRoom._id === roomId) {
        state.singleRoom = {
          ...state.singleRoom,
          messages: []
        };
      }

      if (state.chat && state.chat.length > 0) {
        const roomIndex = state.chat.findIndex(room => room._id === roomId);
        if (roomIndex !== -1) {
          state.chat[roomIndex] = {
            ...state.chat[roomIndex],
            messages: [],
            unreadCount: 0,
            lastMessage: null,
            lastMessageTime: null
          };
          state.chat = [...state.chat];
        }
      }
    },

    updateChatRoomAfterClear(state, roomId) {
      if (state.chat && state.chat.length > 0) {
        const roomIndex = state.chat.findIndex(room => room._id === roomId);
        if (roomIndex !== -1) {
          state.chat[roomIndex].lastMessage = null;
          state.chat[roomIndex].lastMessageTime = null;
          state.chat[roomIndex].unreadCount = 0;
        }
      }
    },

    REMOVE_MESSAGE(state, { roomId, messageId }) {
      if (state.singleRoom && state.singleRoom._id === roomId) {
        state.singleRoom.messages = state.singleRoom.messages.filter(
          msg => msg._id !== messageId
        );
      }

      if (state.chat && state.chat.length > 0) {
        const roomIndex = state.chat.findIndex(room => room._id === roomId);
        if (roomIndex !== -1) {
          state.chat[roomIndex].messages = state.chat[roomIndex].messages.filter(
            msg => msg._id !== messageId
          );
        }
      }
    },

    REPLACE_TEMP_MESSAGE(state, { roomId, tempId, messageID }) {
      if (state.singleRoom && state.singleRoom._id === roomId) {
        const messageIndex = state.singleRoom.messages.findIndex(
          msg => msg._id === tempId
        );
        if (messageIndex !== -1) {
          const updatedMessage = {
            ...state.singleRoom.messages[messageIndex],
            _id: messageID,
            sending: false,
            failed: false
          };
          state.singleRoom.messages.splice(messageIndex, 1, updatedMessage);
        }
      }

      if (state.chat && state.chat.length > 0) {
        const roomIndex = state.chat.findIndex(room => room._id === roomId);
        if (roomIndex !== -1) {
          const messageIndex = state.chat[roomIndex].messages.findIndex(
            msg => msg._id === tempId
          );
          if (messageIndex !== -1) {
            const updatedMessage = {
              ...state.chat[roomIndex].messages[messageIndex],
              _id: messageID,
              sending: false,
              failed: false
            };
            state.chat[roomIndex].messages.splice(messageIndex, 1, updatedMessage);
          }
        }
      }
    },

    MARK_MESSAGE_FAILED(state, { roomId, tempId }) {
      if (state.singleRoom && state.singleRoom._id === roomId) {
        const messageIndex = state.singleRoom.messages.findIndex(
          msg => msg._id === tempId
        );
        if (messageIndex !== -1) {
          state.singleRoom.messages[messageIndex].failed = true;
          state.singleRoom.messages[messageIndex].sending = false;
        }
      }

      if (state.chat && state.chat.length > 0) {
        const roomIndex = state.chat.findIndex(room => room._id === roomId);
        if (roomIndex !== -1) {
          const messageIndex = state.chat[roomIndex].messages.findIndex(
            msg => msg._id === tempId
          );
          if (messageIndex !== -1) {
            state.chat[roomIndex].messages[messageIndex].failed = true;
            state.chat[roomIndex].messages[messageIndex].sending = false;
          }
        }
      }
    },

    // Mark message as deleted for everyone
    MARK_MESSAGE_DELETED_FOR_EVERYONE(state, { roomId, messageId }) {
      const updateMessage = (messages) => {
        if (!messages) return;
        const msgIndex = messages.findIndex(m => m._id === messageId);
        if (msgIndex !== -1) {
          // isDeleted stays false — backend keeps it visible as a system message
          messages[msgIndex].isDeleted = false;
          messages[msgIndex].text = "This message was deleted";
          messages[msgIndex].attachments = [];
          messages[msgIndex].messageType = "system";
          messages[msgIndex].systemMeta = {
            action: "message_deleted",
            summary: "Message was deleted",
          };
        }
      };

      if (state.singleRoom && state.singleRoom._id === roomId) {
        updateMessage(state.singleRoom.messages);
      }

      const chatIndex = state.chat.findIndex(c => c._id === roomId);
      if (chatIndex !== -1) {
        updateMessage(state.chat[chatIndex].messages);
      }
    },

    // New mutation: Add member to group
    // In chat.js - mutations

    ADD_GROUP_MEMBER(state, { groupId, member }) {
      // Update in chat list
      const chatIndex = state.chat.findIndex(c => c._id === groupId);
      if (chatIndex !== -1 && state.chat[chatIndex]) {
        if (!state.chat[chatIndex].participants) {
          state.chat[chatIndex].participants = [];
        }
        // Check if member already exists
        const exists = state.chat[chatIndex].participants.some(
          p => (p._id || p.userID) === (member._id || member.userID)
        );
        if (!exists) {
          state.chat[chatIndex].participants.push(member);
        }
        // Preserve messages
        if (!state.chat[chatIndex].messages) {
          state.chat[chatIndex].messages = [];
        }
      }

      if (state.singleRoom && state.singleRoom._id === groupId) {
        if (!state.singleRoom.participants) {
          state.singleRoom.participants = [];
        }
        const exists = state.singleRoom.participants.some(
          p => (p._id || p.userID) === (member._id || member.userID)
        );
        if (!exists) {
          state.singleRoom.participants.push(member);
        }
        // Preserve messages
        if (!state.singleRoom.messages) {
          state.singleRoom.messages = [];
        }
      }
    },


    // New mutation: Remove member from group
    // In chat.js - mutations

    REMOVE_GROUP_MEMBER(state, { groupId, memberId }) {
      // Update in chat list
      const chatIndex = state.chat.findIndex(c => c && c._id === groupId);
      if (chatIndex !== -1 && state.chat[chatIndex]) {
        // Ensure participants exists
        if (state.chat[chatIndex].participants && Array.isArray(state.chat[chatIndex].participants)) {
          state.chat[chatIndex].participants = state.chat[chatIndex].participants.filter(
            p => {
              const pId = p._id || p.userID;
              return pId && pId.toString() !== memberId.toString();
            }
          );
        }

        // Ensure groupAdmins exists
        if (state.chat[chatIndex].groupAdmins && Array.isArray(state.chat[chatIndex].groupAdmins)) {
          state.chat[chatIndex].groupAdmins = state.chat[chatIndex].groupAdmins.filter(
            admin => admin._id && admin._id.toString() !== memberId.toString()
          );
        }
      }

      // Update in single room
      if (state.singleRoom && state.singleRoom._id === groupId) {
        if (state.singleRoom.participants && Array.isArray(state.singleRoom.participants)) {
          state.singleRoom.participants = state.singleRoom.participants.filter(
            p => {
              const pId = p._id || p.userID;
              return pId && pId.toString() !== memberId.toString();
            }
          );
        }

        if (state.singleRoom.groupAdmins && Array.isArray(state.singleRoom.groupAdmins)) {
          state.singleRoom.groupAdmins = state.singleRoom.groupAdmins.filter(
            admin => admin._id && admin._id.toString() !== memberId.toString()
          );
        }
      }
    },
    // chat.js (mutations)
REPLACE_TEMP_CHAT(state, { tempId, newChat }) {
  if (!tempId || !newChat) return;

  const realId = newChat._id;

  // Remove the old temp entry AND any pre-existing entry with the real id
  // (e.g. added earlier via a "new-message"/UPDATE_CHAT socket event)
  state.chat = state.chat.filter(
    (c) => c && c._id !== tempId && c._id !== realId
  );

  state.chat.unshift(newChat);

  if (state.singleRoom && state.singleRoom._id === tempId) {
    state.singleRoom = {
      ...state.singleRoom,
      ...newChat,
      messages: newChat.messages || state.singleRoom.messages || [],
      selectedUser: newChat.selectedUser || state.singleRoom.selectedUser
    };
  }
},
    // New mutation: Add reaction to message
    ADD_REACTION(state, { roomId, messageId, reaction }) {
      const updateMessageReactions = (messages) => {
        if (!messages) return;
        const msgIndex = messages.findIndex(m => m._id === messageId);
        if (msgIndex !== -1) {
          if (!messages[msgIndex].reactions) {
            messages[msgIndex].reactions = [];
          }
          // Check if user already reacted with this emoji
          const existingIndex = messages[msgIndex].reactions.findIndex(
            r => r.emoji === reaction.emoji && (r.userId === reaction.userId || r.userID === reaction.userID)
          );
          if (existingIndex !== -1) {
            // Update existing reaction (shouldn't happen with proper logic)
            messages[msgIndex].reactions[existingIndex] = reaction;
          } else {
            messages[msgIndex].reactions.push(reaction);
          }
        }
      };

      if (state.singleRoom && state.singleRoom._id === roomId) {
        updateMessageReactions(state.singleRoom.messages);
      }

      const chatIndex = state.chat.findIndex(c => c._id === roomId);
      if (chatIndex !== -1) {
        updateMessageReactions(state.chat[chatIndex].messages);
      }
    },
    // In the mutations section
    UPDATE_MESSAGE_PIN(state, { roomId, messageId, isPinned }) {
      const updatePinStatus = (messages) => {
        if (!messages) return;
        const msgIndex = messages.findIndex(m => m._id === messageId);
        if (msgIndex !== -1) {
          messages[msgIndex].isPinned = isPinned;
          if (isPinned) {
            messages[msgIndex].pinnedAt = new Date();
          } else {
            delete messages[msgIndex].pinnedAt;
          }
        }
      };

      // Update in single room
      if (state.singleRoom && state.singleRoom._id === roomId) {
        updatePinStatus(state.singleRoom.messages);
      }

      // Update in chat list
      const chatIndex = state.chat.findIndex(c => c._id === roomId);
      if (chatIndex !== -1) {
        updatePinStatus(state.chat[chatIndex].messages);
      }
    },
    // In the mutations section
    REMOVE_REACTION(state, { roomId, messageId, emoji, userId }) {
      const updateMessageReactions = (messages) => {
        if (!messages) return;
        const msgIndex = messages.findIndex(m => m._id === messageId);
        if (msgIndex !== -1 && messages[msgIndex].reactions) {
          const reactionIndex = messages[msgIndex].reactions.findIndex(
            r => r.emoji === emoji && (r.userId === userId || r.userID === userId)
          );
          if (reactionIndex !== -1) {
            messages[msgIndex].reactions.splice(reactionIndex, 1);
          }
        }
      };

      if (state.singleRoom && state.singleRoom._id === roomId) {
        updateMessageReactions(state.singleRoom.messages);
      }

      const chatIndex = state.chat.findIndex(c => c._id === roomId);
      if (chatIndex !== -1) {
        updateMessageReactions(state.chat[chatIndex].messages);
      }
    },

    // New mutation: Update message (edit)
    UPDATE_MESSAGE(state, { roomId, messageId, newText }) {
      const updateMessageText = (messages) => {
        const msgIndex = messages.findIndex(m => m._id === messageId);
        if (msgIndex !== -1) {
          messages[msgIndex].text = newText;
          messages[msgIndex].edited = true;
          messages[msgIndex].editedAt = new Date();
        }
      };

      if (state.singleRoom && state.singleRoom._id === roomId) {
        updateMessageText(state.singleRoom.messages);
      }

      const chatIndex = state.chat.findIndex(c => c._id === roomId);
      if (chatIndex !== -1) {
        updateMessageText(state.chat[chatIndex].messages);
        // Update last message if it was the last one
        const messages = state.chat[chatIndex].messages;
        if (messages.length > 0 && messages[messages.length - 1]._id === messageId) {
          state.chat[chatIndex].lastMessage = newText;
        }
      }
    },

    // In the mutations section
    UPDATE_MESSAGE_REACTIONS(state, { roomId, messageId, reactions }) {
      const updateReactions = (messages) => {
        if (!messages) return;
        const msgIndex = messages.findIndex(m => m._id === messageId);
        if (msgIndex !== -1) {
          messages[msgIndex].reactions = reactions;
        }
      };

      // Update in single room
      if (state.singleRoom && state.singleRoom._id === roomId) {
        updateReactions(state.singleRoom.messages);
      }

      // Update in chat list
      const chatIndex = state.chat.findIndex(c => c._id === roomId);
      if (chatIndex !== -1) {
        updateReactions(state.chat[chatIndex].messages);
      }
    },

    // New mutation: Pin/unpin chat
    TOGGLE_PIN_CHAT(state, { chatId, isPinned }) {
      const chatIndex = state.chat.findIndex(c => c && (c._id === chatId || c.id === chatId));
      if (chatIndex !== -1) {
        // Update the chat
        state.chat[chatIndex] = {
          ...state.chat[chatIndex],
          isPinned: isPinned
        };

        // Move pinned chats to the top
        if (isPinned) {
          const chat = state.chat.splice(chatIndex, 1)[0];
          // Find the first unpinned chat position
          let insertIndex = state.chat.findIndex(c => !c.isPinned);
          if (insertIndex === -1) insertIndex = state.chat.length;
          state.chat.splice(insertIndex, 0, chat);
        }

        // Ensure reactivity
        state.chat = [...state.chat];
      }
    },

    // New mutation: Mute/unmute chat
    TOGGLE_MUTE_CHAT(state, { chatId, isMuted }) {
      const chatIndex = state.chat.findIndex(c => c._id === chatId);
      if (chatIndex !== -1) {
        state.chat[chatIndex].isMuted = isMuted;
      }
    },

    // New mutation: Add wallpaper
    SET_CHAT_WALLPAPER(state, { chatId, wallpaper }) {
      const chatIndex = state.chat.findIndex(c => c._id === chatId);
      if (chatIndex !== -1) {
        state.chat[chatIndex].wallpaper = wallpaper;
      }

      if (state.singleRoom && state.singleRoom._id === chatId) {
        state.singleRoom.wallpaper = wallpaper;
      }
    },

    // New mutation: Delete chat for me
    DELETE_CHAT_FOR_ME(state, chatId) {
      state.chat = state.chat.filter(c => c && c._id !== chatId && c.id !== chatId);
      if (state.singleRoom && state.singleRoom._id === chatId) {
        state.singleRoom = null;
      }
    },
    MARK_CHAT_DELETED(state, chatId) {
      const chatIndex = state.chat.findIndex(c => c && (c._id === chatId || c.id === chatId));
      if (chatIndex !== -1) {
        state.chat[chatIndex].isDeletedForMe = true;
        state.chat[chatIndex].deletedAt = new Date();
        // Optionally remove from list or hide it
        state.chat = state.chat.filter(c => !(c.isDeletedForMe && c._id === chatId));
      }
    },

    // New mutation: Clear all messages for me
    CLEAR_ALL_MESSAGES_FOR_ME(state, { chatId }) {
      if (state.singleRoom && state.singleRoom._id === chatId) {
        state.singleRoom.messages = [];
      }

      const chatIndex = state.chat.findIndex(c => c._id === chatId);
      if (chatIndex !== -1) {
        state.chat[chatIndex].messages = [];
        state.chat[chatIndex].lastMessage = null;
        state.chat[chatIndex].lastMessageTime = null;
        state.chat[chatIndex].unreadCount = 0;
      }
    }
  },

  actions: {
    // Get volunteers and agencies list
    getVolunteersAndAgencies({ rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("chat/getVolunteersAndAgencies")
          .then(res => {
            if (res.data.success === true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },


    getChatById({ commit, rootState }, chatId) {
      return new Promise((resolve, reject) => {
        if (!chatId) {
          reject(new Error("Chat ID is required"));
          return;
        }

        axiosInstance(rootState.auth.token)
          .post("chat/getChat", { chatId })
          .then(res => {
            if (res.data.success === true) {
              // Handle different response structures
              let chatData = res.data.chat || res.data.res || res.data;

              // If chatData is wrapped in a res property
              if (chatData && chatData.res) {
                chatData = chatData.res;
              }

              // Ensure chatData has an _id
              if (!chatData || !chatData._id) {
                reject(new Error("Invalid chat data received"));
                return;
              }

              // Ensure participants have user data
              if (chatData.participants && Array.isArray(chatData.participants)) {
                chatData.participants = chatData.participants.map(p => ({
                  ...p,
                  _id: p._id || p.userID || p.id
                }));
              }

              // Ensure messages array exists
              if (!chatData.messages) {
                chatData.messages = res.data.messages || [];
              }

              // Ensure recentMessages exists
              if (!chatData.recentMessages) {
                chatData.recentMessages = res.data.recentMessages || chatData.messages;
              }

              // Filter out null messages
              if (Array.isArray(chatData.messages)) {
                chatData.messages = chatData.messages.filter(msg => msg !== null);
              }

              // Commit to store
              commit("setSingleRoom", chatData);

              // Also update the chat list
              if (chatData._id) {
                const chatIndex = rootState.chat.chat.findIndex(c => {
                  if (!c) return false;
                  return c._id === chatData._id || c.id === chatData._id;
                });

                if (chatIndex !== -1) {
                  // Update existing chat in list
                  const updatedChat = {
                    ...rootState.chat.chat[chatIndex],
                    ...chatData,
                    messages: chatData.messages || []
                  };
                  commit("UPDATE_CHAT", updatedChat);
                } else {
                  // Add to chat list if not exists
                  commit("ADD_CHAT", chatData);
                }
              }

              resolve(chatData);
            } else {
              reject(res.data.message || "Failed to get chat");
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Get chat by conversation key
    getChatByConversationKey({ commit, rootState }, conversationKey) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("chat/getChatByConversationKey", { conversationKey })
          .then(res => {
            if (res.data.success === true) {
              commit("setSingleRoom", res.data.chat);
              resolve(res.data.chat);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Get all chats for a user
    getAllChats({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("chat/getUserChats")
          .then(res => {
            if (res.data.success === true) {
              // Handle different response structures
              let chats = res.data.chats || res.data.res || res.data || [];

              // If chats is an object with a res property
              if (chats.res && Array.isArray(chats.res)) {
                chats = chats.res;
              }

              // If chats is not an array, try to convert it
              if (!Array.isArray(chats)) {
                chats = [chats].filter(c => c && c._id);
              }

              // Ensure each chat has an _id and messages array
              chats = chats.filter(chat => chat && chat._id).map(chat => ({
                ...chat,
                messages: chat.messages || chat.recentMessages || [],
                recentMessages: chat.recentMessages || chat.messages || []
              }));

              commit("SET_CHAT", chats);
              resolve(chats);
            } else {
              reject(res.data.message || "Failed to get chats");
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Add a message to a chat
    addNewMessage({ commit, rootState }, payload) {
      const isFormData = typeof FormData !== "undefined" && payload instanceof FormData;

      const tempRoomId = isFormData ? payload.get("tempRoomId") : payload.tempRoomId;
      const clientMessageId = isFormData ? payload.get("clientMessageId") : payload.clientMessageId;
      const replyToData = isFormData ? payload.get("replyTo") : payload.replyTo;

      // Parse replyTo if it's a string (from FormData)
      let parsedReplyTo = replyToData;
      if (isFormData && typeof replyToData === 'string') {
        try {
          parsedReplyTo = JSON.parse(replyToData);
        } catch (e) {
          console.warn('Failed to parse replyTo data:', e);
        }
      }

      return new Promise((resolve, reject) => {
        // If we have reply data, use the reply endpoint
        if (parsedReplyTo && parsedReplyTo.messageId) {
          const replyPayload = {
            chatId: tempRoomId || payload.chatId || payload.get?.('chatId'),
            replyToMessageId: parsedReplyTo.messageId, // Changed from messageId to replyToMessageId
            messageType: isFormData ? payload.get('messageType') : payload.messageType,
            text: isFormData ? payload.get('text') : payload.text,
            // Add mediaUrl if files are included
            mediaUrl: parsedReplyTo.mediaUrl || null
          };

          // If there are files in FormData, we need to handle them differently
          // The backend currently only accepts mediaUrl, not file uploads for replies
          // So we'll send the reply as text with the reply data
          axiosInstance(rootState.auth.token)
            .post("chat/replyToMessage", replyPayload)
            .then(res => {
              const serverMessage = res?.data?.message;
              if (tempRoomId && clientMessageId && serverMessage) {
                commit("REPLACE_TEMP_MESSAGE", {
                  roomId: tempRoomId,
                  tempId: clientMessageId,
                  messageID: serverMessage._id
                });
              }
              resolve(res.data);
            })
            .catch(err => {
              if (tempRoomId && clientMessageId) {
                commit("MARK_MESSAGE_FAILED", {
                  roomId: tempRoomId,
                  tempId: clientMessageId
                });
              }
              reject(err);
            });
        } else {
          // Regular message send - this handles both JSON and FormData
          const config = isFormData ? {
            headers: { 'Content-Type': 'multipart/form-data' }
          } : {};

          axiosInstance(rootState.auth.token)
            .post("chat/sendMessage", payload, config)
            .then(res => {
              const serverMessage = res?.data?.message;
              if (tempRoomId && clientMessageId && serverMessage) {
                commit("REPLACE_TEMP_MESSAGE", {
                  roomId: tempRoomId,
                  tempId: clientMessageId,
                  messageID: serverMessage._id
                });
              }
              resolve(res.data);
            })
            .catch(err => {
              if (tempRoomId && clientMessageId) {
                commit("MARK_MESSAGE_FAILED", {
                  roomId: tempRoomId,
                  tempId: clientMessageId
                });
              }
              reject(err);
            });
        }
      });
    },


    // Edit a message
    editMessage({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("chat/editMessage", payload)
          .then(res => {
            if (res.data.success === true) {
              commit("UPDATE_MESSAGE", {
                roomId: payload.chatId,
                messageId: payload.messageId,
                newText: payload.newText
              });
              resolve(res.data);
            } else {
              reject(res.data.message || "Failed to edit message");
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Delete a message for me
    deleteMessage({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("chat/deleteMessage", payload)
          .then(res => {
            if (res.data.success === true) {
              commit("REMOVE_MESSAGE", {
                roomId: payload.chatId,
                messageId: payload.messageId
              });
              resolve(res.data);
            } else {
              reject(res.data.message || "Failed to delete message");
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Delete a message for everyone
    deleteMessageForEveryone({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("chat/deleteMessageForEveryone", payload)
          .then(res => {
            if (res.data.success === true) {
              // Update local state
              commit("MARK_MESSAGE_DELETED_FOR_EVERYONE", {
                roomId: payload.chatId,
                messageId: payload.messageId,
              });
              resolve(res.data);
            } else {
              reject(res.data.message || "Failed to delete message");
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Mark messages as read
    markMessagesAsRead({ commit, rootState, state }, payload) {
      return new Promise((resolve, reject) => {
        // Ensure we have the required fields
        if (!payload.chatId) {
          reject(new Error("chatId is required"));
          return;
        }

        // If lastReadSequence is not provided, use a default
        if (!payload.lastReadSequence) {
          payload.lastReadSequence = 0;
        }

        axiosInstance(rootState.auth.token)
          .post("chat/markAsRead", payload)
          .then(res => {
            if (res.data.success === true) {
              // Update unread count in state
              if (state.unreadmessageCount > 0) {
                const newCount = Math.max(0, state.unreadmessageCount - 1);
                commit("SET_UNREAD_MESSAGES_COUNT", newCount);
              }

              // Update the chat's unread count for the current user
              const chatIndex = state.chat.findIndex(c => c && c._id === payload.chatId);
              if (chatIndex !== -1 && state.chat[chatIndex]) {
                if (state.chat[chatIndex].unreadCount) {
                  state.chat[chatIndex].unreadCount[rootState.auth.profile._id] = 0;
                }
                state.chat[chatIndex].currentUserUnreadCount = 0;
              }

              resolve(res.data);
            } else {
              reject(res.data.message || "Failed to mark messages as read");
            }
          })
          .catch(error => {
            console.error("markMessagesAsRead error:", error);
            reject(error);
          });
      });
    },

    // Add reaction to a message
    addReaction({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("chat/addReaction", {
            messageId: payload.messageId,
            chatId: payload.chatId,
            emoji: payload.emoji
          })
          .then(res => {
            if (res.data.success === true) {
              // Update the local state with the new reactions
              commit("UPDATE_MESSAGE_REACTIONS", {
                roomId: payload.chatId,
                messageId: payload.messageId,
                reactions: res.data.reactions
              });
              resolve(res.data);
            } else {
              reject(res.data.message || "Failed to update reaction");
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Remove reaction (now handled by the same endpoint with toggle)
    removeReaction({ dispatch }, payload) {
      // Since the backend uses toggle, we can just call addReaction
      // with the same payload
      return dispatch("addReaction", payload);
    },

    // Reply to a message
    // Reply to a message
    replyToMessage({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        const isFormData = typeof FormData !== "undefined" && payload instanceof FormData;

        const config = isFormData ? {
          headers: { 'Content-Type': 'multipart/form-data' }
        } : {};

        axiosInstance(rootState.auth.token)
          .post("chat/replyToMessage", payload, config)
          .then(res => {
            if (res.data.success === true) {
              // If we have a message, update the chat
              if (res.data.message) {
                const message = res.data.message;
                const chatId = isFormData ? payload.get('chatId') : payload.chatId;

                // Add message to the chat
                if (chatId) {
                  const chatIndex = rootState.chat.chat.findIndex(c => c._id === chatId);
                  if (chatIndex !== -1) {
                    if (!rootState.chat.chat[chatIndex].messages) {
                      rootState.chat.chat[chatIndex].messages = [];
                    }
                    rootState.chat.chat[chatIndex].messages.push(message);
                    rootState.chat.chat[chatIndex].lastMessage = message;
                    rootState.chat.chat[chatIndex].lastActivityAt = new Date();
                  }

                  // Update single room if it's the current chat
                  if (rootState.chat.singleRoom && rootState.chat.singleRoom._id === chatId) {
                    if (!rootState.chat.singleRoom.messages) {
                      rootState.chat.singleRoom.messages = [];
                    }
                    rootState.chat.singleRoom.messages.push(message);
                    rootState.chat.singleRoom.lastMessage = message;
                    rootState.chat.singleRoom.lastActivityAt = new Date();
                  }
                }
              }
              resolve(res.data);
            } else {
              reject(res.data.message || "Failed to reply to message");
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Pin a chat
    pinChat({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("chat/pinChat", { chatId: payload.chatId })
          .then(res => {
            if (res.data.success === true) {
              // Update local state
              commit("TOGGLE_PIN_CHAT", {
                chatId: payload.chatId,
                isPinned: res.data.pinned
              });
              resolve(res.data);
            } else {
              reject(res.data.message || "Failed to pin chat");
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Pin a message
    pinMessage({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("chat/pinMessage", {
            messageId: payload.messageId,
            chatId: payload.chatId
          })
          .then(res => {
            if (res.data.success === true) {
              resolve(res.data);
            } else {
              reject(res.data.message || "Failed to pin message");
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Create a new group chat
    createGroupChat({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        // Check if payload is FormData (for image upload)
        const isFormData = typeof FormData !== "undefined" && payload instanceof FormData;

        const config = isFormData ? {
          headers: { 'Content-Type': 'multipart/form-data' }
        } : {
          headers: { 'Content-Type': 'application/json' }
        };

        let data = payload;

        // If it's not FormData, ensure participantIds is an array
        if (!isFormData) {
          data = { ...payload };

          // Handle participantIds if it's a string
          if (typeof data.participantIds === 'string') {
            try {
              data.participantIds = JSON.parse(data.participantIds);
            } catch (e) {
              console.warn('Failed to parse participantIds:', e);
              data.participantIds = [];
            }
          }

          // Ensure participantIds is an array
          if (!Array.isArray(data.participantIds)) {
            data.participantIds = [];
          }
        }

        console.log('Sending create group request:', data);

        axiosInstance(rootState.auth.token)
          .post("chat/createGroupChat", data, config)
          .then(res => {
            if (res.data.success === true) {
              const groupChat = res.data.res || res.data.groupChat;
              if (groupChat && groupChat._id) {
                commit("ADD_CHAT", groupChat);
              }
              resolve(groupChat || res.data);
            } else {
              reject(res.data.message || "Failed to create group");
            }
          })
          .catch(error => {
            console.error('Group creation error:', error.response?.data || error.message);
            reject(error);
          });
      });
    },

    // Add a member to a group chat
    addMemberToGroupChat({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        // Map frontend payload to backend expected format
        const requestData = {
          chatId: payload.groupId || payload.chatId,
          newMemberId: payload.newMemberId || payload.memberId || payload.userId,
          newMemberType: payload.newMemberType || payload.userType || 'User'
        };

        console.log('addMemberToGroupChat request:', requestData);

        axiosInstance(rootState.auth.token)
          .post("chat/addMemberToGroupChat", requestData)
          .then(res => {
            if (res.data.success === true) {
              // Update local state
              if (res.data.res) {
                // Ensure participants array exists
                if (!res.data.res.participants) {
                  res.data.res.participants = [];
                }
                if (!res.data.res.groupAdmins) {
                  res.data.res.groupAdmins = [];
                }

                commit("UPDATE_CHAT", res.data.res);
                // Also update single room if it's the current chat
                if (rootState.chat.singleRoom && rootState.chat.singleRoom._id === requestData.chatId) {
                  commit("setSingleRoom", res.data.res);
                }
              }
              resolve(res.data);
            } else {
              reject(new Error(res.data.message || "Failed to add member"));
            }
          })
          .catch(error => {
            console.error("addMemberToGroupChat error:", error.response?.data || error.message);
            reject(error);
          });
      });
    },

    // Remove a member from a group chat
    removeMemberFromGroupChat({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        // Map frontend payload to backend expected format
        const requestData = {
          chatId: payload.groupId || payload.chatId,
          memberId: payload.memberId || payload.userId
        };

        console.log('removeMemberFromGroupChat request:', requestData);

        axiosInstance(rootState.auth.token)
          .post("chat/removeMemberFromGroupChat", requestData)
          .then(res => {
            if (res.data.success === true) {
              // The response data is in res.data.res
              const updatedChat = res.data.res;

              // Ensure arrays exist
              if (updatedChat) {
                if (!updatedChat.participants) updatedChat.participants = [];
                if (!updatedChat.groupAdmins) updatedChat.groupAdmins = [];
                if (!updatedChat.messages) updatedChat.messages = [];
              }

              // Update the chat in the store
              commit("UPDATE_CHAT", updatedChat);

              // Also update single room if it's the current chat
              if (rootState.chat.singleRoom && rootState.chat.singleRoom._id === requestData.chatId) {
                commit("setSingleRoom", updatedChat);
              }

              // Commit the removal mutation to update local state
              commit("REMOVE_GROUP_MEMBER", {
                groupId: requestData.chatId,
                memberId: requestData.memberId
              });

              resolve(res.data);
            } else {
              reject(new Error(res.data.message || "Failed to remove member"));
            }
          })
          .catch(error => {
            console.error("removeMemberFromGroupChat error:", error.response?.data || error.message);
            reject(error);
          });
      });
    },

    // Leave a group chat
    leaveGroupChat({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const requestData = {
          chatId: payload.groupId || payload.chatId,
          userId: payload.userId
        };

        console.log('leaveGroupChat request:', requestData);

        axiosInstance(rootState.auth.token)
          .post("chat/leaveGroupChat", requestData)
          .then(res => {
            if (res.data.success === true) {
              // Remove the group from chat list
              commit("DELETE_CHAT_FOR_ME", requestData.chatId);

              // Also clear from single room if it's the current chat
              if (rootState.chat.singleRoom && rootState.chat.singleRoom._id === requestData.chatId) {
                commit("setSingleRoom", null);
              }

              resolve(res.data);
            } else {
              reject(new Error(res.data.message || "Failed to leave group"));
            }
          })
          .catch(error => {
            console.error("leaveGroupChat error:", error.response?.data || error.message);
            reject(error);
          });
      });
    },

    // Update group chat details (name, image, description)
    // In chat.js - actions

    // In chat.js - updateGroupChatDetails action

    updateGroupChatDetails({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        const isFormData = typeof FormData !== "undefined" && payload instanceof FormData;

        let requestData;
        let config = {};

        if (isFormData) {
          requestData = payload;
          config = {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          };
        } else {
          const { groupId, updates } = payload;
          requestData = {
            chatId: groupId,
            chatName: updates?.name || updates?.chatName,
            chatDescription: updates?.description || updates?.chatDescription,
            chatImage: updates?.groupImage || updates?.image
          };
        }

        axiosInstance(rootState.auth.token)
          .post("chat/updateGroupChatDetails", requestData, config)
          .then(res => {
            if (res.data.success === true) {
              const chatId = isFormData ? payload.get('chatId') : payload.groupId;

              // Get the updated chat data
              const updatedChat = res.data.data?.chat || res.data.chat;
              const currentValues = res.data.data?.currentValues || {};

              // Update local store - PRESERVE EXISTING MESSAGES
              if (updatedChat) {
                // Get existing messages from store
                const existingChat = rootState.chat.singleRoom;
                const existingMessages = existingChat?.messages || [];

                // Merge the updated chat with existing messages
                const mergedChat = {
                  ...updatedChat,
                  // Preserve existing messages if the response doesn't have them
                  messages: updatedChat.messages && updatedChat.messages.length > 0
                    ? updatedChat.messages
                    : existingMessages
                };

                commit("UPDATE_GROUP_DETAILS", {
                  groupId: chatId,
                  updates: {
                    name: currentValues.name || updatedChat.name,
                    description: currentValues.description || updatedChat.description,
                    groupImage: currentValues.groupImage || updatedChat.groupImage,
                    messages: mergedChat.messages
                  }
                });

                commit("setSingleRoom", mergedChat);
                commit("UPDATE_CHAT", mergedChat);
              } else if (currentValues) {
                // If only currentValues are returned
                commit("UPDATE_GROUP_DETAILS", {
                  groupId: chatId,
                  updates: currentValues
                });
              }

              resolve(res.data);
            } else {
              reject(new Error(res.data.message || "Failed to update group details"));
            }
          })
          .catch(error => {
            console.error("updateGroupChatDetails error:", error.response?.data || error.message);
            reject(error);
          });
      });
    },
    // Make a group admin
    makeGroupAdmin({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        // Ensure we have the correct parameter name
        const requestData = {
          chatId: payload.groupId,
          userId: payload.userId // Send as userId to match backend
        };

        // If the backend expects memberId, we can add both
        if (payload.memberId) {
          requestData.memberId = payload.memberId;
        }

        axiosInstance(rootState.auth.token)
          .post("chat/makeGroupAdmin", requestData)
          .then(res => {
            if (res.data.success === true) {
              resolve(res.data);
            } else {
              reject(res.data.message || "Failed to make admin");
            }
          })
          .catch(error => {
            console.error("makeGroupAdmin error:", error.response?.data || error.message);
            reject(error);
          });
      });
    },

    // Remove a group admin
    removeGroupAdmin({ rootState }, payload) {
      return new Promise((resolve, reject) => {
        // Ensure we have the correct parameter name
        const requestData = {
          chatId: payload.groupId,
          userId: payload.userId // Send as userId to match backend
        };

        // If the backend expects memberId, we can add both
        if (payload.memberId) {
          requestData.memberId = payload.memberId;
        }

        axiosInstance(rootState.auth.token)
          .post("chat/removeGroupAdmin", requestData)
          .then(res => {
            if (res.data.success === true) {
              resolve(res.data);
            } else {
              reject(res.data.message || "Failed to remove admin");
            }
          })
          .catch(error => {
            console.error("removeGroupAdmin error:", error.response?.data || error.message);
            reject(error);
          });
      });
    },

    // In chat.js - actions section
    clearChatHistory({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("chat/clearChatHistory", payload)
          .then(res => {
            if (res.data.success === true) {
              commit("clearRoomMessages", payload.chatId);
              commit("updateChatRoomAfterClear", payload.chatId);
              resolve(res.data);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Alias for clearChatHistory
    clearChat({ dispatch }, payload) {
      return dispatch("clearChatHistory", payload);
    },

    // Clear all messages for me
    clearAllMessagesForMe({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("chat/clearAllMessagesForMe", payload)
          .then(res => {
            if (res.data.success === true) {
              commit("CLEAR_ALL_MESSAGES_FOR_ME", {
                chatId: payload.chatId
              });
              resolve(res.data);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Delete chat for me
    deleteChatForMe({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("chat/deleteChatForMe", payload)
          .then(res => {
            if (res.data.success === true) {
              // Remove chat from the list
              commit("DELETE_CHAT_FOR_ME", payload.chatId);
              resolve(res.data);
            } else {
              reject(res.data.message || "Failed to delete chat");
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Add wallpaper to a chat
    addWallpaper({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("chat/addWallpaper", payload)
          .then(res => {
            if (res.data.success === true) {
              commit("SET_CHAT_WALLPAPER", {
                chatId: payload.chatId,
                wallpaper: payload.wallpaper
              });
              resolve(res.data);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Mute a chat
    muteChat({ commit, rootState }, payload) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("chat/muteChat", payload)
          .then(res => {
            if (res.data.success === true) {
              commit("TOGGLE_MUTE_CHAT", {
                chatId: payload.chatId,
                isMuted: payload.isMuted
              });
              resolve(res.data);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Get unread message count
    getUnreadMessageCount({ commit, rootState }) {
      return new Promise((resolve, reject) => {
        // This uses the markAsRead endpoint with a special flag
        axiosInstance(rootState.auth.token)
          .post("chat/markAsRead", { getUnreadCount: true })
          .then(res => {
            if (res.data.success === true) {
              commit("SET_UNREAD_MESSAGES_COUNT", res.data.unreadCount);
              resolve(res.data.unreadCount);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Add message from FCM (push notification)
    addMessageFromFcm({ commit, state }, params) {
      if (state.singleRoom._id === params.roomID) {
        let existingMessageIndex = state.singleRoom.messages.findIndex(
          message => message._id === params._id
        );
        if (existingMessageIndex === -1) {
          state.singleRoom.messages.push(params);
        }
      }

      if (state.chat && state.chat.length > 0) {
        let roomIndex = state.chat.findIndex(room => room._id === params.roomID);
        if (roomIndex !== -1) {
          let existingMessageIndex = state.chat[roomIndex].messages.findIndex(
            message => message?._id === params._id
          );
          if (existingMessageIndex === -1) {
            state.chat[roomIndex].messages.push(params);
            if (state.singleRoom && state.singleRoom._id !== params.roomID) {
              state.chat[roomIndex].unreadCount += 1;
            }
            commit("SET_UNREAD_MESSAGES_COUNT", state.unreadmessageCount + 1);
          }
          let room = state.chat.splice(roomIndex, 1);
          state.chat.unshift(room[0]);
        }
      }
    },

    // Update chat with message read status
    updateChatwithMessageReadStatus({ state }, params) {
      if (state.chat && state.chat.length > 0) {
        let roomIndex = state.chat.findIndex(room => room._id === params.roomID);
        if (roomIndex !== -1) {
          let messageIndex = state.chat[roomIndex].messages.findIndex(
            message => message._id === params._id
          );
          if (messageIndex !== -1) {
            state.chat[roomIndex].messages[messageIndex].read = true;
          }
        }
      }
    },

    // Replace temp message
    replaceTempMessage({ commit }, { roomId, tempId, messageID }) {
      commit("REPLACE_TEMP_MESSAGE", { roomId, tempId, messageID });
    },

    // Mark message as failed
    markMessageFailed({ commit }, { roomId, tempId }) {
      commit("MARK_MESSAGE_FAILED", { roomId, tempId });
    },

    // Alias for markMessagesAsRead
    markMessageAsRead({ dispatch }, payload) {
      return dispatch("markMessagesAsRead", payload);
    },

    // Alias for getChatById
    getChat({ dispatch }, chatId) {
      return dispatch("getChatById", chatId);
    },

    // Search users (compatibility with existing code)
    searchUsers({ rootState }, key) {
      return new Promise((resolve, reject) => {
        axiosInstance(rootState.auth.token)
          .post("chat/getVolunteersAndAgencies", { search: key })
          .then(res => {
            if (res.data.success === true) {
              resolve(res.data.res);
            } else {
              reject(res.data.message);
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // getGroupChatInfo
    getGroupChatInfo({ rootState }, chatId) {
      return new Promise((resolve, reject) => {
        if (!chatId) {
          reject(new Error("Chat ID is required"));
          return;
        }

        axiosInstance(rootState.auth.token)
          .post("chat/getGroupChatInfo", { chatId })
          .then(res => {
            if (res.data.success === true) {
              resolve(res.data.chat);
            } else {
              reject(res.data.message || "Failed to get group info");
            }
          })
          .catch(error => {
            reject(error);
          });
      });
    },

    // Handle an incoming socket "new-message" event globally (e.g. from App.vue)
    receiveMessage({ commit, state }, payload) {
      return new Promise((resolve) => {
        const chatId = String(payload?.chatId || "");
        const message = payload?.message;
        if (!chatId || !message) return resolve();

        commit("UPDATE_CHAT", {
          _id: chatId,
          lastMessage: message,
          lastActivityAt: message.createdAt || new Date().toISOString()
        });

        // Bump unread count only if this chat isn't the one currently open
        if (!(state.singleRoom && String(state.singleRoom._id) === chatId)) {
          const chatIndex = state.chat.findIndex((c) => c && c._id === chatId);
          if (chatIndex !== -1) {
            const chat = state.chat[chatIndex];
            chat.currentUserUnreadCount = (chat.currentUserUnreadCount || 0) + 1;
          }
        }
        resolve();
      });
    },
  }
};